<template>
    <div>
        <register-fom/>
    </div>
</template>
<script>
import RegisterFom from '../../components/auth/RegisterFom'
export default {
    components:{
        RegisterFom,
    }
}
</script>
